import { TokenExchangeRequest, TokenExchangeResponse } from 'api';
import type { CancelablePromise } from 'api/core/CancelablePromise';
import type { OpenAPIConfig } from 'api/core/OpenAPI';
import { OpenAPI } from 'api/core/OpenAPI';
import { request as __request } from 'api/core/request';

export type TokenExchangeRequestOptions = {
  /**
   * When true, axios will send/receive cookies for this request.
   * Useful when the backend relies on session/CSRF cookies.
   */
  withCredentials?: boolean;

  /** Optional OpenAPI overrides for advanced cases. */
  openApiConfig?: Partial<OpenAPIConfig>;
};

/**
 * Like SsoService.apiSsoExchangeCreate, but allows per-call OpenAPI overrides.
 * This avoids mutating the global OpenAPI singleton.
 */
export const apiSsoTokenExchange = (
  data: TokenExchangeRequest,
  options: TokenExchangeRequestOptions = {}
): CancelablePromise<TokenExchangeResponse> => {
  const effectiveConfig: OpenAPIConfig = {
    ...OpenAPI,
    ...options.openApiConfig,
    WITH_CREDENTIALS: options.withCredentials ?? OpenAPI.WITH_CREDENTIALS,
  };

  return __request(effectiveConfig, {
    method: 'POST',
    url: '/api/sso/exchange',
    body: data,
  });
};
